var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/types/masonry-engine-action.types.ts
var MasonryEngineEvent = /* @__PURE__ */ ((MasonryEngineEvent2) => {
  MasonryEngineEvent2["STARTED"] = "started";
  MasonryEngineEvent2["ENDED"] = "ended";
  MasonryEngineEvent2["ALL"] = "all";
  return MasonryEngineEvent2;
})(MasonryEngineEvent || {});

// src/masonry-engine.component.tsx
import React4, {
  useCallback as useCallback4,
  useEffect as useEffect2,
  useMemo as useMemo3,
  useRef as useRef3
} from "react";
import {
  captureMessage as captureMessage2,
  ObservabilityErrorBoundary as ObservabilityErrorBoundary2
} from "@leagueplatform/observability";
import { subscribeToMessage } from "@leagueplatform/socket-as-fetch";
import { getScopedCssClassnames } from "@leagueplatform/ui-kit";

// src/use-instance-modal.tsx
import React, {
  memo,
  useCallback,
  useRef,
  useState
} from "react";
import {
  Button,
  HeadingText,
  Modal,
  ParagraphText,
  StackLayout
} from "@leagueplatform/genesis-core";
var InstanceModal = ({
  payload,
  onModalOpenChange,
  onCloseAutoFocus
}) => /* @__PURE__ */ React.createElement(Modal.Root, { open: !!payload, onOpenChange: onModalOpenChange }, /* @__PURE__ */ React.createElement(
  Modal.Content,
  {
    onCloseAutoFocus,
    width: { "@initial": 384, "@mobile": "100%" }
  },
  /* @__PURE__ */ React.createElement(StackLayout, { spacing: "$oneAndHalf" }, (payload == null ? void 0 : payload.heading) && /* @__PURE__ */ React.createElement(Modal.Title, null, /* @__PURE__ */ React.createElement(
    HeadingText,
    {
      level: "display",
      size: "sm",
      css: { alignSelf: "center" }
    },
    payload.heading
  )), (payload == null ? void 0 : payload.body) && /* @__PURE__ */ React.createElement(Modal.Description, null, /* @__PURE__ */ React.createElement(ParagraphText, { emphasis: "subtle" }, payload.body)), (payload == null ? void 0 : payload.ctaLabel) && /* @__PURE__ */ React.createElement(Modal.Close, null, /* @__PURE__ */ React.createElement(Button, { width: "fillContainer" }, payload.ctaLabel)))
));
var useInstanceModal = () => {
  const [payload, setPayload] = useState();
  const showModal = useCallback(
    (options) => {
      setPayload(options);
    },
    []
  );
  const prevPayloadRef = useRef();
  const onModalOpenChange = useCallback((open) => {
    if (!open) {
      setPayload((currentPayload) => {
        prevPayloadRef.current = currentPayload;
        return void 0;
      });
    }
  }, []);
  const onCloseAutoFocus = useCallback(
    (event) => {
      event.preventDefault();
      if (prevPayloadRef.current) {
        prevPayloadRef.current.elementToFocusOnClose.focus();
      }
      prevPayloadRef.current = void 0;
    },
    []
  );
  const InstanceModalComponent = memo(() => /* @__PURE__ */ React.createElement(
    InstanceModal,
    {
      payload,
      onModalOpenChange,
      onCloseAutoFocus
    }
  ));
  return [InstanceModalComponent, showModal];
};

// src/components/node-resolver.component.tsx
import React3, {
  useCallback as useCallback3,
  useContext as useContext4,
  useEffect,
  useMemo as useMemo2,
  useRef as useRef2
} from "react";
import {
  ObservabilityErrorBoundary,
  captureError,
  captureMessage
} from "@leagueplatform/observability";
import { useQuery } from "@tanstack/react-query";
import { debounce } from "lodash";
import { createTheme } from "@leagueplatform/genesis-core";
import set from "lodash/set";

// src/masonry-engine-config-context.ts
import { createContext, useContext } from "react";
var MasonryEngineConfigContext = createContext(void 0);
var getMasonryEngineConfigContext = () => MasonryEngineConfigContext;
var useMasonryEngineConfig = () => {
  const config = useContext(getMasonryEngineConfigContext());
  if (!config) {
    throw new Error(
      "MasonryEngine component must be rendered within the context of a Masonry Engine flow!"
    );
  }
  return config;
};

// src/utils/log.ts
var MasonryLogPreffix = "[MasonryEngine]:";
var logError = (msg) => {
  if (true) {
    console.log(`%c${MasonryLogPreffix} ${msg}`, "color: red");
  }
};
var logWarning = (msg) => {
  if (true) {
    console.log(`%c${MasonryLogPreffix} ${msg}`, "color: yellow");
  }
};

// src/utils/masonry-engine-observability-content.ts
var getMasonryEngineObservabilityContext = (context) => __spreadProps(__spreadValues({}, context), {
  tags: __spreadValues({
    dependentModule: "masonry-engine",
    supportTeam: "masonry-web"
  }, context == null ? void 0 : context.tags)
});

// src/masonry-engine-node-ancestry-context.tsx
import React2, { createContext as createContext2, useContext as useContext2, useMemo } from "react";
var MasonryEngineNodeAncestryContext = createContext2([]);
var MasonryEngineNodeAncestryProvider = ({
  children,
  nodeId
}) => {
  const upperAncestry = useContext2(MasonryEngineNodeAncestryContext);
  const newAncestry = useMemo(
    () => [nodeId, ...upperAncestry],
    [nodeId, upperAncestry]
  );
  return /* @__PURE__ */ React2.createElement(MasonryEngineNodeAncestryContext.Provider, { value: newAncestry }, children);
};

// src/utils/get-breakpoint.ts
import { mediaQueryMap } from "@leagueplatform/genesis-core";
var getCurrentBreakpoint = (breakpoints = mediaQueryMap) => {
  var _a, _b;
  return (_b = (_a = Object.entries(breakpoints).find(
    ([, query]) => window.matchMedia(query).matches
  )) == null ? void 0 : _a[0]) != null ? _b : void 0;
};

// src/masonry-engine-action-controller.tsx
import { useCallback as useCallback2, useContext as useContext3 } from "react";
import { useNavigate } from "@leagueplatform/routing";

// src/masonry-engine-default-validation-handlers-map.tsx
var RequiredValidationHandler = (value, { required }) => {
  if (required) {
    if (value === void 0 || value === null || value === "") {
      return false;
    }
  }
  return true;
};
var MinValidationHandler = (value, { min }) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue) || numericValue < min) {
    return false;
  }
  return true;
};
var MaxValidationHandler = (value, { max }) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue) || numericValue > max) {
    return false;
  }
  return true;
};
var MinLengthValidationHandler = (value, { minLength }) => {
  if (typeof value !== "string" || value.length < minLength) {
    return false;
  }
  return true;
};
var MaxLengthValidationHandler = (value, { maxLength }) => {
  if (typeof value !== "string" || value.length > maxLength) {
    return false;
  }
  return true;
};
var PatternValidationHandler = (value, { pattern }) => {
  if (typeof value !== "string" || !new RegExp(pattern).test(value)) {
    return false;
  }
  return true;
};
var masonryEngineDefaultValidationHandlerMap = {
  required: RequiredValidationHandler,
  minLength: MinLengthValidationHandler,
  maxLength: MaxLengthValidationHandler,
  min: MinValidationHandler,
  max: MaxValidationHandler,
  pattern: PatternValidationHandler
};

// src/masonry-engine-validation-controller.tsx
var validationHandlerMap = __spreadValues({}, masonryEngineDefaultValidationHandlerMap);
var MasonryEngineValidationController = {
  /**
   * Registers a validation handler for a specific validation name.
   *
   * @param validationType - The name of the validation to register.
   * @param handler - The validation handler function to register.
   *
   * @throws {Error} If a validation handler for the specified name already exists.
   *
   */
  registerValidationHandler: (validationType, handler) => {
    if (validationType in validationHandlerMap) {
      throw new Error(
        `Validation handler for ${validationType} already exists.`
      );
    }
    validationHandlerMap[validationType] = handler;
  },
  /**
   *
   * Validates an array of form field nodes against their defined validation rules.
   * @param fieldNodes - An array of form field nodes to validate.
   *
   * @returns {FormValidationResult} An object containing validation results for each field node.
   *
   */
  validateFormFields: (fieldNodes) => {
    const validationResult = [];
    fieldNodes.forEach((fieldData) => {
      const {
        nodeId,
        value,
        formFieldProperties: { formFieldId, validationRules }
      } = fieldData;
      if (!validationRules) {
        return;
      }
      for (const validationRule of validationRules) {
        const {
          validationType,
          payload: validationValue,
          statusMessage,
          statusType
        } = validationRule;
        const validationHandler = validationHandlerMap[validationType];
        if (!validationHandler) {
          throw new Error(
            `No validation handler registered for ${validationType}.`
          );
        }
        const isValid = validationHandler(value, validationValue);
        if (!isValid) {
          validationResult.push({
            nodeId,
            formFieldId,
            statusType,
            statusMessage
          });
          break;
        }
      }
    });
    return validationResult;
  },
  /**
   * Updates the state of form field nodes with validation messages.
   *
   * @param validationResult - The validation results object containing status messages and types.
   * @param fieldNodes - An array of form field nodes to update.
   * @param stateController - The state controller to update the field nodes' states.
   *
   */
  updateFieldNodesWithValidationMessages: (validationResult, fieldNodes, stateController) => {
    fieldNodes.forEach((fieldData) => {
      const { nodeId } = fieldData;
      const fieldValidationResult = validationResult.find(
        (result) => result.nodeId === nodeId
      );
      stateController.setNodeState(
        nodeId,
        (state) => __spreadProps(__spreadValues({}, state), {
          formFieldProperties: __spreadProps(__spreadValues({}, state.formFieldProperties), {
            // set status type to undefined if there is no validation result
            // this will clear any previous validation status
            inputStatus: (fieldValidationResult == null ? void 0 : fieldValidationResult.statusType) || void 0,
            statusMessage: (fieldValidationResult == null ? void 0 : fieldValidationResult.statusMessage) || void 0
          })
        })
      );
    });
  },
  /**
   * Given a `ValidationResult` and the Messaging Controller provided to the action handler,
   * will focus the first invalid field in the form (or do nothing if there are no invalid fields).
   * @param validationResult - The validation results object containing status messages and types.
   * @param messagingController - the Messaging Controller provided to the action handler.
   */
  focusFirstInvalidField: (validationResult, messagingController) => __async(void 0, null, function* () {
    const rootElements = (yield Promise.all(
      validationResult.map((result) => __async(void 0, null, function* () {
        const rooteElement = yield messagingController.sendMessage(result.nodeId, {
          type: "getRootElement",
          payload: {}
        });
        if (!rooteElement) {
          logWarning(
            `The renderer for field node ${result.nodeId} did not provide a root element ref!`
          );
        }
        return rooteElement;
      }))
    )).filter(Boolean);
    const firstElementIndex = rootElements.reduce(
      (currentEarliestIndex, currentElement, currentIndex) => {
        if (!rootElements[currentEarliestIndex]) {
          logWarning(
            `The renderer for field node ${validationResult[currentIndex].nodeId} did not provide a root element ref!`
          );
          return currentEarliestIndex;
        }
        if (
          // eslint-disable-next-line no-bitwise
          rootElements[currentEarliestIndex].compareDocumentPosition(
            currentElement
          ) & Node.DOCUMENT_POSITION_FOLLOWING
        ) {
          return currentEarliestIndex;
        }
        return currentIndex;
      },
      0
    );
    return messagingController.sendMessage(
      validationResult[firstElementIndex].nodeId,
      {
        type: "focus",
        payload: {}
      }
    );
  })
};

// src/utils/formatEventName.ts
var formatEventName = (namespace, actionType, eventType) => `${namespace}-${eventType}-${actionType}`;

// src/constants/constants.ts
var DEFAULT_NAMESPACE = "default";
var MasonryEngineLevelActionNames = ["onLoad"];

// src/masonry-engine-action-controller.tsx
var masonryEngineEventNamesExceptALL = Object.values(
  MasonryEngineEvent
).filter((type) => type !== "all" /* ALL */);
var createMasonryEngineActionController = (defaultHandlers) => {
  const actionRegistry = {
    default: defaultHandlers
  };
  const eventListenerMap = {};
  const registerHandler = (type, namespace, handler) => {
    actionRegistry[namespace] = actionRegistry[namespace] || {};
    if (actionRegistry[namespace][type]) {
      throw new Error(
        "Attempting to register a handler for a type at a namespace where a handler was already registered for that type!"
      );
    }
    actionRegistry[namespace][type] = handler;
  };
  const overrideHandler = (type, namespace, handler) => {
    actionRegistry[namespace] = actionRegistry[namespace] || {};
    actionRegistry[namespace][type] = handler;
  };
  const invokeAction = (invokedAction, ...resources) => __async(void 0, null, function* () {
    var _a, _b, _c, _d;
    const action = __spreadProps(__spreadValues({}, invokedAction), {
      ancestry: invokedAction.ancestry || []
    });
    const chainAction = invokeAction;
    const handler = (_a = actionRegistry[action.namespace]) == null ? void 0 : _a[action.type];
    if (!handler) {
      throw new Error(
        `Masonry Engine: No action - ${action.type} found for namespace - ${action.namespace}`
      );
    }
    const startedEventName = formatEventName(
      action.namespace,
      action.type,
      "started" /* STARTED */
    );
    (_b = eventListenerMap[startedEventName]) == null ? void 0 : _b.forEach((listener) => {
      listener(action, void 0);
    });
    console.debug("Masonry Engine Action emitted", action);
    const returnValue = yield Promise.resolve(
      handler(
        action,
        (chainedAction) => chainAction(chainedAction, ...resources),
        ...resources
      )
    );
    const endedEventName = formatEventName(
      action.namespace,
      action.type,
      "ended" /* ENDED */
    );
    (_c = eventListenerMap[endedEventName]) == null ? void 0 : _c.forEach((listener) => {
      listener(action, returnValue);
    });
    const analyticsHandler = (_d = actionRegistry[action.namespace]) == null ? void 0 : _d.analytics;
    if (action.analytics && analyticsHandler) {
      const analyticsPayload = {
        type: "analytics",
        namespace: DEFAULT_NAMESPACE,
        payload: action.analytics,
        ancestry: action.ancestry
      };
      chainAction(analyticsPayload, ...resources);
    }
    return returnValue;
  });
  const addEventListener = (actionType, namespace, eventType, listener) => {
    const resolvedEventTypes = eventType === "all" /* ALL */ ? masonryEngineEventNamesExceptALL : [eventType];
    resolvedEventTypes.forEach((resolvedEventType) => {
      const formattedEventName = formatEventName(
        namespace,
        actionType,
        resolvedEventType
      );
      eventListenerMap[formattedEventName] = eventListenerMap[formattedEventName] || /* @__PURE__ */ new Set();
      eventListenerMap[formattedEventName].add(listener);
    });
    return () => {
      resolvedEventTypes.forEach((resolvedEventType) => {
        const formattedEventName = formatEventName(
          namespace,
          actionType,
          resolvedEventType
        );
        eventListenerMap[formattedEventName].delete(listener);
      });
    };
  };
  const getRegisteredEventListeners = () => {
    const record = {};
    Object.entries(eventListenerMap).forEach(([eventType, listenerSet]) => {
      if (listenerSet == null ? void 0 : listenerSet.size) {
        record[eventType] = listenerSet.size;
      }
    });
    return record;
  };
  return {
    registerHandler,
    overrideHandler,
    invokeAction,
    addEventListener,
    getRegisteredEventListeners
  };
};
var useMasonryEngineActionEmitter = () => {
  const ancestry = useContext3(MasonryEngineNodeAncestryContext);
  const {
    actionController: { invokeAction },
    /**
     * Pass vanilla zustand store directly instead of passing State controller from React Context, so that
     * users creating this outside of react should be able to use the store directly instead of relying
     * on React specific stuff.
     */
    stateControllerStore,
    messagingController
  } = useMasonryEngineConfig();
  const navigate = useNavigate();
  return useCallback2(
    (invokedAction) => {
      var _a;
      const action = __spreadProps(__spreadValues({}, invokedAction), {
        ancestry: (_a = invokedAction.ancestry) != null ? _a : ancestry
      });
      return invokeAction(
        action,
        stateControllerStore.getState(),
        messagingController,
        MasonryEngineValidationController,
        { navigate }
      );
    },
    [
      ancestry,
      invokeAction,
      messagingController,
      navigate,
      stateControllerStore
    ]
  );
};

// src/masonry-engine-state-controller.ts
import { createStore } from "zustand/vanilla";
import { useStoreWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/vanilla/shallow";
import { produce } from "immer";
var createStateControllerStore = () => {
  const stateControllerStore = createStore(
    (set2, get) => ({
      nodeStateMap: {},
      formFieldNodesMap: {},
      setNodeState: (nodeId, producer) => set2(
        (store) => produce(store, (storeDraft) => {
          const currentNodeState = storeDraft.nodeStateMap[nodeId];
          if (!currentNodeState) {
            throw new Error(
              "Trying to set the state of a node whose state was not yet initialized!"
            );
          }
          storeDraft.nodeStateMap[nodeId] = producer(currentNodeState);
        })
      ),
      setInitialNodeState: (nodeId, newNodeState) => set2(
        (store) => produce(store, (storeDraft) => {
          storeDraft.nodeStateMap[nodeId] = __spreadProps(__spreadValues({}, newNodeState), { nodeId });
          const { formFieldProperties } = newNodeState;
          if (formFieldProperties == null ? void 0 : formFieldProperties.formFieldId) {
            storeDraft.formFieldNodesMap[formFieldProperties.formId] = [
              ...storeDraft.formFieldNodesMap[formFieldProperties.formId] || [],
              nodeId
            ];
          }
        })
      ),
      clearNodeState: (nodeId) => set2(
        (store) => produce(store, (storeDraft) => {
          delete storeDraft.nodeStateMap[nodeId];
        })
      ),
      getNodeState: (nodeId) => {
        const store = get();
        return store.nodeStateMap[nodeId];
      },
      getFormFieldNodesMap: (formId) => {
        const store = get();
        return store.formFieldNodesMap[formId];
      }
    })
  );
  return stateControllerStore;
};
var useStateControllerStore = (selector) => {
  const { stateControllerStore } = useMasonryEngineConfig();
  return useStoreWithEqualityFn(stateControllerStore, selector, shallow);
};
var INITIAL_COMMON_STATE = {
  isVisible: true
};
var useSectionNodeStates = (sectionNodes) => useStateControllerStore(
  (state) => sectionNodes.map((node) => state.getNodeState(node.id))
);

// src/components/node-resolver.component.tsx
var updateNodeState = (stateControllerStore, node) => {
  const { setInitialNodeState, getNodeState, setNodeState } = stateControllerStore.getState();
  if (getNodeState(node.id)) {
    setNodeState(node.id, (current) => __spreadValues(__spreadValues({}, current), node.properties));
  } else {
    setInitialNodeState(node.id, __spreadValues(__spreadValues({}, node.properties), INITIAL_COMMON_STATE));
  }
};
var QUERY_KEY_GET_NODE_ASYNC_SELF = "MASONRY_ENGINE_GET_NODE_ASYNC_SELF";
var NodeResolver = ({
  node: originalNode
}) => {
  var _a, _b, _c;
  const {
    nodeRenderers,
    stateControllerStore,
    messagingController,
    staticQueryParams
  } = useMasonryEngineConfig();
  const queryParamsRef = useRef2({});
  const isRoot = useContext4(MasonryEngineNodeAncestryContext).length === 0;
  const isAsync = !!originalNode.getAsyncSelf;
  const {
    error,
    /**
     * "fresh", as in fetched asynchronously if this is an async node, or simply
     * the original node otherwise (since in that context, original IS "fresh").
     */
    data: freshNode,
    isFetching,
    refetch
  } = useQuery(
    [
      QUERY_KEY_GET_NODE_ASYNC_SELF,
      originalNode.id,
      staticQueryParams,
      queryParamsRef.current
    ],
    () => __async(void 0, null, function* () {
      const newNodeData = yield originalNode.getAsyncSelf(__spreadValues(__spreadValues({}, isRoot ? staticQueryParams : {}), queryParamsRef.current));
      updateNodeState(stateControllerStore, newNodeData);
      return newNodeData;
    }),
    {
      enabled: isAsync,
      /**
       * we WANT to fetch when this component mounts.
       */
      refetchOnMount: true,
      /**
       * we DO NOT WANT to fetch when the tab/window is re-focused or when
       * an offline client reconnects, because we don't want to overwrite any
       * state changes that may have occurred client-side since this component mounted.
       */
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      keepPreviousData: true
    }
  );
  useEffect(() => {
    if (!isAsync) {
      updateNodeState(stateControllerStore, originalNode);
    }
    return () => {
      const { clearNodeState } = stateControllerStore.getState();
      if (clearNodeState) {
        clearNodeState(originalNode.id);
      }
    };
  }, [isAsync, originalNode, stateControllerStore]);
  const node = freshNode || originalNode;
  const nodeTheme = useMemo2(() => {
    if (!node.themeOverrides) {
      return "";
    }
    const tokens = Object.entries(node.themeOverrides).reduce(
      (acc, [token, value]) => {
        set(acc, token, value);
        return acc;
      },
      {}
    );
    return createTheme(tokens);
  }, [node.themeOverrides]);
  const invokeAction = useMasonryEngineActionEmitter();
  const upperAncestry = useContext4(MasonryEngineNodeAncestryContext);
  const ancestry = useMemo2(
    () => [node.id, ...upperAncestry],
    [node.id, upperAncestry]
  );
  const hasInvokedEngineActionsRef = useRef2(false);
  useEffect(() => {
    var _a2;
    if (!hasInvokedEngineActionsRef.current && ((_a2 = node.actions) == null ? void 0 : _a2.onLoad)) {
      invokeAction(__spreadProps(__spreadValues({}, node.actions.onLoad), {
        ancestry
      }));
      hasInvokedEngineActionsRef.current = true;
    }
  }, [ancestry, invokeAction, (_a = node.actions) == null ? void 0 : _a.onLoad, node.id]);
  const rootElementRef = useRef2();
  const rootElementRefCallback = (instance) => {
    if (instance) {
      rootElementRef.current = instance;
    }
  };
  const reloadMessageRef = useRef2(void 0);
  const isReloading = isFetching && !!reloadMessageRef.current;
  const shouldShowLoader = isReloading && ((_b = reloadMessageRef.current) == null ? void 0 : _b.renderIntermediately) === "loader";
  const reloadPromiseResolverRef = useRef2();
  useEffect(() => {
    var _a2;
    if (!reloadMessageRef.current) {
      (_a2 = reloadPromiseResolverRef.current) == null ? void 0 : _a2.call(reloadPromiseResolverRef);
      reloadPromiseResolverRef.current = void 0;
    }
  }, [isReloading]);
  const reloadHandler = useCallback3(
    (messagePayload) => __async(void 0, null, function* () {
      if (!originalNode.getAsyncSelf) {
        throw new Error("Trying to reload a sync node!");
      }
      if (messagePayload.setQueryParams) {
        queryParamsRef.current = messagePayload.setQueryParams(
          queryParamsRef.current
        );
      }
      reloadMessageRef.current = messagePayload;
      const reloadPromise = new Promise((resolve) => {
        reloadPromiseResolverRef.current = resolve;
      });
      yield refetch();
      reloadMessageRef.current = void 0;
      yield reloadPromise;
    }),
    [originalNode.getAsyncSelf, refetch]
  );
  const getQueryParamsHandler = useCallback3(
    () => Promise.resolve(__spreadValues(__spreadValues({}, staticQueryParams), queryParamsRef.current)),
    [staticQueryParams]
  );
  useEffect(() => {
    var _a2;
    const onResizeAction = (_a2 = node.actions) == null ? void 0 : _a2.onResize;
    if (!onResizeAction)
      return void 0;
    const breakpoints = onResizeAction.payload.screenSizeBreakpoints;
    if (!Array.isArray(breakpoints))
      return void 0;
    let lastBreakpoint = getCurrentBreakpoint();
    const handleResize = debounce(() => {
      const currentBreakpoint = getCurrentBreakpoint();
      if (currentBreakpoint !== lastBreakpoint) {
        lastBreakpoint = currentBreakpoint;
        if (breakpoints.includes(currentBreakpoint)) {
          invokeAction(__spreadProps(__spreadValues({}, onResizeAction), { ancestry }));
        }
      }
    }, 250);
    window.addEventListener("resize", handleResize);
    return () => {
      handleResize.cancel();
      window.removeEventListener("resize", handleResize);
    };
  }, [ancestry, invokeAction, (_c = node.actions) == null ? void 0 : _c.onResize]);
  const stateFromController = useStateControllerStore(
    (store) => store.getNodeState(node.id)
  );
  const resolvedState = (
    /**
     * When reloading we always use the properties of `originalNode`, since we want
     * to show loaders during this time.
     */
    shouldShowLoader ? __spreadValues(__spreadValues({}, originalNode.properties), INITIAL_COMMON_STATE) : (
      /**
       * Otherwise, if we've already set this node's state in the state controller
       * during a previous render, we will simply use that.
       */
      stateFromController || /**
      * But if this is the first render and this node's state has not yet been set
      * in the state controller, we will use its properties and spread our initial
      * common state values (e.g., `isVisible: true`).
      */
      __spreadValues(__spreadValues({}, node.properties), INITIAL_COMMON_STATE)
    )
  );
  useEffect(() => {
    const messageReceiver = (message) => __async(void 0, null, function* () {
      switch (message.type) {
        case "getQueryParams":
          return getQueryParamsHandler();
        case "reload":
          yield reloadHandler(message.payload);
          break;
        case "focus":
          if (rootElementRef.current) {
            const originalTabIndex = rootElementRef.current.tabIndex;
            rootElementRef.current.tabIndex = -1;
            rootElementRef.current.focus();
            rootElementRef.current.tabIndex = originalTabIndex;
          }
          break;
        case "getRootElement":
          return rootElementRef.current;
        case "serverAction":
          yield invokeAction(__spreadProps(__spreadValues({}, message.payload.action), { ancestry }));
          break;
        default:
          const exhaustiveCheck = message;
          captureMessage(`Received unhandled node message ${exhaustiveCheck}`, {
            severityLevel: "warning"
          });
      }
      return void 0;
    });
    if (messageReceiver) {
      messagingController.registerReceiver(node.id, messageReceiver);
    }
    return () => {
      messagingController.unregisterReceiver(node.id);
    };
  }, [
    invokeAction,
    node.id,
    messagingController,
    reloadHandler,
    getQueryParamsHandler,
    ancestry
  ]);
  if (error) {
    logError(
      `Error while making api call for node id ${originalNode.id} ${error}`
    );
    captureError(
      new Error(
        `MasonryEngine - Error while making api call for node id ${originalNode.id} ${error}`
      ),
      getMasonryEngineObservabilityContext({})
    );
    return null;
  }
  if (!resolvedState.isVisible)
    return null;
  const nodeNamespace = node.namespace || DEFAULT_NAMESPACE;
  const nodeRendererMapForNamespace = nodeRenderers[nodeNamespace];
  const nodeType = !shouldShowLoader ? node.type : originalNode.type;
  const NodeRenderer = nodeRendererMapForNamespace == null ? void 0 : nodeRendererMapForNamespace[nodeType];
  if (!NodeRenderer) {
    logError(
      `Could not find renderer for namespace - ${nodeNamespace} & node type - ${node.type} !`
    );
    captureError(
      new Error(
        `MasonryEngine - Could not find renderer for namespace - ${nodeNamespace} & node type - ${node.type} !`
      ),
      getMasonryEngineObservabilityContext({})
    );
    return null;
  }
  const resolvedSections = node.sections ? Object.fromEntries(
    Object.entries(node.sections).map(([section, subnodes]) => [
      section,
      subnodes.map((subnode) => /* @__PURE__ */ React3.createElement(NodeResolver, { key: subnode.id, node: subnode }))
    ])
  ) : {};
  const filteredNodeActions = node.actions ? Object.fromEntries(
    Object.entries(node.actions).filter(
      ([key]) => !MasonryEngineLevelActionNames.includes(key)
    )
  ) : {};
  const nodeRendererProps = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, resolvedState), resolvedSections), filteredNodeActions), {
    rootElementRef: rootElementRefCallback,
    className: nodeTheme,
    nodeId: node.id,
    nodeData: node,
    isReloading
  });
  return /* @__PURE__ */ React3.createElement(MasonryEngineNodeAncestryProvider, { nodeId: node.id || originalNode.id }, /* @__PURE__ */ React3.createElement(
    ObservabilityErrorBoundary,
    {
      errorContext: getMasonryEngineObservabilityContext({
        tags: {
          errorName: `MasonryEngine - Error while rendering Masonry Engine Node id: ${originalNode.id}`
        }
      }),
      onError: (err) => {
        logError(
          `Error while rendering Masonry Engine Node id: ${originalNode.id} ${err.message}`
        );
      }
    },
    /* @__PURE__ */ React3.createElement(NodeRenderer, __spreadValues({}, nodeRendererProps))
  ));
};

// src/masonry-engine-messaging-controller.ts
import { captureError as captureError2 } from "@leagueplatform/observability";
var createMessagingController = (instanceReceiver) => {
  const nodeMessageReceiverMap = /* @__PURE__ */ new Map();
  return {
    registerReceiver: (nodeId, receiver) => {
      nodeMessageReceiverMap.set(nodeId, receiver);
    },
    unregisterReceiver: (nodeId) => {
      nodeMessageReceiverMap.delete(nodeId);
    },
    sendMessage: (nodeId, message) => {
      const receiver = nodeMessageReceiverMap.get(nodeId);
      if (receiver) {
        return receiver(message);
      }
      logError(`Could not find message receiver for node ${nodeId}`);
      captureError2(
        new Error(
          `MasonryEngine - Could not find message receiver for node ${nodeId}`
        ),
        getMasonryEngineObservabilityContext({})
      );
      return Promise.resolve();
    },
    sendMessageToInstance: (message) => instanceReceiver(message)
  };
};

// src/masonry-engine.component.tsx
var MasonryEngine = ({
  driver: Driver
}) => {
  const stateControllerStoreRef = useRef3();
  if (!stateControllerStoreRef.current) {
    stateControllerStoreRef.current = createStateControllerStore();
  }
  const [InstanceModal2, showModal] = useInstanceModal();
  const messageReceiver = useCallback4(
    (message) => __async(void 0, null, function* () {
      switch (message.type) {
        case "showModalWithProperties":
          showModal(message.payload);
          break;
        case "noOp":
          break;
        default:
          const exhaustiveCheck = message;
          captureMessage2(`Received unhandled node message ${exhaustiveCheck}`, {
            severityLevel: "warning"
          });
      }
    }),
    [showModal]
  );
  const messagingControllerRef = useRef3();
  if (!messagingControllerRef.current) {
    messagingControllerRef.current = createMessagingController(messageReceiver);
  }
  useEffect2(() => {
    const unsubscribe = subscribeToMessage(
      "masonry_action",
      ({ invoker, action }) => {
        messagingControllerRef.current.sendMessage(invoker, {
          type: "serverAction",
          payload: {
            action
          }
        });
      }
    );
    return unsubscribe;
  }, []);
  const memoized = useMemo3(() => {
    const MasonryEngineConfigProvider = getMasonryEngineConfigContext().Provider;
    const classNames = getScopedCssClassnames();
    return /* @__PURE__ */ React4.createElement(
      ObservabilityErrorBoundary2,
      {
        errorContext: getMasonryEngineObservabilityContext({
          tags: {
            errorName: `MasonryEngine - Error from Masonry Engine`
          }
        }),
        onError: (err) => {
          logError(`Error from Masonry Engine: ${err.message}`);
        }
      },
      /* @__PURE__ */ React4.createElement(Driver, null, (node, nodeRenderers, actionController, staticQueryParams) => /* @__PURE__ */ React4.createElement(
        MasonryEngineConfigProvider,
        {
          value: {
            nodeRenderers,
            actionController,
            stateControllerStore: stateControllerStoreRef.current,
            messagingController: messagingControllerRef.current,
            staticQueryParams
          }
        },
        classNames && classNames.trim() !== "" ? /* @__PURE__ */ React4.createElement("div", { "data-testid": "css-reset-wrapper", className: classNames }, /* @__PURE__ */ React4.createElement(NodeResolver, { node })) : /* @__PURE__ */ React4.createElement(NodeResolver, { node })
      ))
    );
  }, [Driver]);
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, memoized, /* @__PURE__ */ React4.createElement(InstanceModal2, null));
};
export {
  DEFAULT_NAMESPACE,
  MasonryEngine,
  MasonryEngineConfigContext,
  MasonryEngineEvent,
  MasonryEngineValidationController,
  createMasonryEngineActionController,
  createMessagingController,
  createStateControllerStore,
  getCurrentBreakpoint,
  useMasonryEngineActionEmitter,
  useSectionNodeStates
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-engine'] = window.leagueSDKsPresent['@leagueplatform/masonry-engine'] || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-engine'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/masonry-engine'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/masonry-engine module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map